const REVIEWS = [
  {
    name: "Marcus D.",
    role: "Low-Voltage Tech · NorthGrid Networks",
    quote:
      "Ten weeks in I was terminating fiber I couldn't even identify before. Twelve weeks after graduation I was pulling $62k plus overtime. This place is legit.",
    image:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20confident%20young%20male%20technician%20wearing%20workwear%20and%20a%20cap%2C%20warm%20workshop%20lighting%20in%20the%20background%2C%20friendly%20natural%20smile%2C%20candid%20editorial%20portrait%20photography%2C%20crisp%20detail%2C%20warm%20amber%20tones&width=400&height=400&seq=techy-testimonial-01&orientation=squarish",
  },
  {
    name: "Alicia R.",
    role: "Fire Alarm Technician · FireGuard Solutions",
    quote:
      "I came in from retail with zero tech background. The instructors are working techs — they show you the way the job actually gets done in the field.",
    image:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20confident%20female%20technician%20wearing%20work%20polo%20shirt%20and%20safety%20glasses%20on%20forehead%2C%20warm%20workshop%20lighting%20in%20the%20background%2C%20natural%20friendly%20expression%2C%20candid%20editorial%20portrait%20photography%2C%20warm%20amber%20tones%2C%20highly%20detailed&width=400&height=400&seq=techy-testimonial-02&orientation=squarish",
  },
  {
    name: "Devon K.",
    role: "Field IT Tech · Vertex IT Group",
    quote:
      "Everyone says 'hands-on.' TechyBootcamp actually means it. I never sat through a slide deck for more than 20 minutes without touching real gear.",
    image:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20confident%20young%20IT%20technician%20wearing%20a%20button%20up%20shirt%20holding%20a%20laptop%20under%20one%20arm%2C%20warm%20office%20workshop%20lighting%20background%2C%20friendly%20candid%20expression%2C%20editorial%20portrait%20photography%2C%20warm%20natural%20tones%2C%20crisp%20high%20detail&width=400&height=400&seq=techy-testimonial-03&orientation=squarish",
  },
];

export default function Testimonials() {
  return (
    <section className="relative bg-background-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-mono uppercase tracking-[0.2em] mb-4">
            <i className="ri-chat-quote-line"></i> Student Stories
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.05]">
            From the classroom to the toolbelt.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {REVIEWS.map((r) => (
            <figure
              key={r.name}
              className="flex flex-col p-6 md:p-7 rounded-xl bg-background-50 border border-background-200"
            >
              <i className="ri-double-quotes-l text-4xl text-primary-500 leading-none mb-3"></i>
              <blockquote className="text-base text-foreground-800 leading-relaxed flex-1">
                {r.quote}
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 pt-5 border-t border-background-200">
                <img
                  src={r.image}
                  alt={r.name}
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <div className="font-heading font-semibold text-foreground-950 text-sm">
                    {r.name}
                  </div>
                  <div className="text-xs text-foreground-600">{r.role}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5 text-primary-500 text-sm">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}